import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  useDisclosure,
  useMergeRefs,
} from '@chakra-ui/react';
import { forwardRef, useRef } from 'react';
import { HiEye, HiEyeOff } from 'react-icons/hi';

interface PasswordFieldProps extends InputProps {
  error: string | undefined;
  title: string,
  name: string
}

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  (props, ref) => {
    const { isOpen, onToggle } = useDisclosure();
    const inputRef = useRef<HTMLInputElement>(null);

    const mergeRef = useMergeRefs(inputRef, ref);
    const onClickReveal = (e: React.MouseEvent) => {
      e.preventDefault();
      onToggle();
      if (inputRef.current) {
        const { selectionStart, selectionEnd } = inputRef.current;
        inputRef.current.focus({ preventScroll: true });
        setTimeout(() => {
         if(inputRef.current) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        }, 0);
      }
    };

    return (
      <FormControl isInvalid={!!props.error}>
        <FormLabel htmlFor="password">{props.title}</FormLabel>
        <InputGroup>
          <InputRightElement>
            <IconButton
              variant="text"
              aria-label={isOpen ? 'Mask password' : 'Reveal password'}
              icon={isOpen ? <HiEyeOff /> : <HiEye />}
              onClick={onClickReveal}
            />
          </InputRightElement>
          <Input
            id="password"
            ref={mergeRef}
            type={isOpen ? 'text' : 'password'}
            autoComplete="current-password"
            required
            {...props}
          />
        </InputGroup>
        {props.error && <FormErrorMessage>{props.error}</FormErrorMessage>}
      </FormControl>
    );
  }
);

PasswordField.displayName = 'PasswordField';
